(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  if (!customElements.get('sb-similar-products')) {
    class SbSimilarProducts extends HTMLElement {
      constructor() {
        super();
        this.list = this.querySelector('[data-sb-similar-list]');
        this.limit = Math.max(1, parseInt(this.dataset.displayLimit || '20', 10));
        this.loadedRelated = false;

        this.rank(false);

        const observer = new IntersectionObserver((entries, io) => {
          if (!entries[0].isIntersecting) return;
          io.unobserve(this);
          this.loadRelated();
        }, { rootMargin: '0px 0px 350px 0px' });
        observer.observe(this);
      }

      compareItems(a, b) {
        const brandA = a.dataset.brandMatch === 'true' ? 1 : 0;
        const brandB = b.dataset.brandMatch === 'true' ? 1 : 0;
        if (brandA !== brandB) return brandB - brandA;

        const scoreA = parseInt(a.dataset.similarityScore || '0', 10);
        const scoreB = parseInt(b.dataset.similarityScore || '0', 10);
        if (scoreA !== scoreB) return scoreB - scoreA;

        const featuresA = parseInt(a.dataset.featureMatches || '0', 10);
        const featuresB = parseInt(b.dataset.featureMatches || '0', 10);
        if (featuresA !== featuresB) return featuresB - featuresA;

        return parseInt(a.dataset.originalIndex || '0', 10) - parseInt(b.dataset.originalIndex || '0', 10);
      }

      rank(trim = true) {
        if (!this.list) return;
        const items = Array.from(this.list.querySelectorAll('.sb-similar-candidate'));
        items.sort((a, b) => this.compareItems(a, b));
        items.forEach(item => this.list.appendChild(item));

        if (trim) {
          items.slice(this.limit).forEach(item => item.remove());
        }

        const kept = Math.min(this.limit, items.length);
        const total = this.querySelector('.slider-counter--total');
        if (total) total.textContent = kept;

        if (kept === 0 && this.loadedRelated) {
          this.hidden = true;
        }
      }

      loadRelated() {
        if (this.loadedRelated || !this.dataset.url) {
          this.loadedRelated = true;
          this.rank(true);
          return;
        }

        this.loadedRelated = true;
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const wrapper = document.createElement('div');
            wrapper.innerHTML = text;
            const source = wrapper.querySelector('[data-sb-related-source]');
            if (!source || !this.list) {
              this.rank(true);
              return;
            }

            const existing = new Set(
              Array.from(this.list.querySelectorAll('.sb-similar-candidate')).map(item => item.dataset.productId)
            );

            source.querySelectorAll('.sb-similar-candidate').forEach(item => {
              if (!existing.has(item.dataset.productId)) {
                existing.add(item.dataset.productId);
                this.list.appendChild(item.cloneNode(true));
              }
            });

            this.rank(true);
          })
          .catch(() => this.rank(true));
      }
    }

    customElements.define('sb-similar-products', SbSimilarProducts);
  }

  } catch(e) { console.error(e); }
})();
})();
